import { useQuery } from "@tanstack/react-query";
import getDoctorList from "api/bookAppointmentOnline/get-doctor-list";

const BOOK_ONLINE_DOCTOR_LIST_KEY = "book_online_doctor_list"
export default function useGetDoctorOnlineOptionList(appointmentTypeId?: string) {
    return useQuery({
        queryKey: [BOOK_ONLINE_DOCTOR_LIST_KEY, appointmentTypeId],
        queryFn: () => getDoctorList(appointmentTypeId),
    });
}
